import { getAvailableMarketSlugs } from '$lib/services/market/utils';

export const match = (market: string) => {
    const availableMarketSlugs = getAvailableMarketSlugs() as string[];
    return availableMarketSlugs.includes(market);
};
